export const APPLY_COUPON = "APPLY_COUPON";
export const COUPON_ERROR = "COUPON_ERROR";
export const GET_COUPONS = "GET_COUPONS";
export const GET_BILL = "GET_BILL";